export function validateTrim(value) {
  if (value && String(value).trim().length !== value.length) {
    return "Value must not start or end with a space";
  }

  return true;
}
